import React from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";

const filter = createFilterOptions({
  stringify: (option) => `${option?.name} ${option?.email} ${option?.mobileNumber}`
});

export default function ContactAutocomplete({ label, field, inputValue, contactsData, contactDraft, setContactDraft, tabIndex }) {

const uniqueOptions = contactsData?.filter(
  (option, index, self) =>
    index ===
    self?.findIndex(
      (o) =>
        o?.name === option?.name &&
        o?.email === option?.email &&
        o?.mobileNumber === option?.mobileNumber
    )
);
  return (
    <Autocomplete
      freeSolo
      options={uniqueOptions}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option[field]
      }
      inputValue={inputValue}
      onInputChange={(e, newValue) => {
        setContactDraft((prev) => ({ ...prev, [field]: newValue }));
      }}
      onChange={(e, selected) => {
        if (selected && typeof selected !== "string") {
          setContactDraft({
            ...contactDraft,
            name: selected.name,
            email: selected.email,
            mobileNumber: selected.mobileNumber,
          });
        }
      }}
      filterOptions={(options) => {
        const query = inputValue.trim().toLowerCase();
        if (!query) return [];
        return options?.filter((opt) => {
          const value = (typeof opt === "string" ? opt : opt[field] || "")
            .trim()
            .toLowerCase();
          return value === query;
        });
      }}
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 1,
            textAlign: "center",
            fontSize: "14px",
            color: "inherit",
          }}
        >
          {field === "email" && (
            <div className="d-flex flex-direction-column flex-justify-start flex-start">
            <span>{option?.email}</span>
            <span>{option?.name} ({option?.mobileNumber})</span>
          </div>
          )
          }
            </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={`${label}`}
          variant="outlined"
          size="small"
          tabIndex={tabIndex}
        />
      )}
    />
  );
}

const maskPhone = (phone) => {
  if (!phone) return "";
  return phone.slice(0, 2) + "•••" + phone.slice(-4);
};